/**
 * Purpose: The handler families a host may supply through {@link IHostHandlerResolver}.
 */
export const HostHandlerKind = {
    /** A server IData producer. */
    Data: 'Data',
    /** A server IClientData raw-data preparer. */
    ClientData: 'ClientData'
} as const;
export type HostHandlerKind = typeof HostHandlerKind[keyof typeof HostHandlerKind];
